import axios from 'axios';

const axiosInstance = () => {
    const instance = axios.create();

    const originalRequest = axios.Axios.prototype.request;

    axios.Axios.prototype.request = function interceptRequest(config) {
        const updatedConfig = Object.assign({}, config, { instance: this });

        const hasMatchingHandler = (handlers, targetHandler) => handlers.some(handler => handler === targetHandler);

        instance.interceptors.request.forEach((interceptor) => {
            const hasFulfilledHandler = hasMatchingHandler(this.interceptors.request.handlers, interceptor.fulfilled);
            const hasRejectedHandler = hasMatchingHandler(this.interceptors.request.handlers, interceptor.rejected);

            if (!hasFulfilledHandler || !hasRejectedHandler) {
                this.interceptors.request.use(interceptor.fulfilled, interceptor.rejected);
            }
        });

        instance.interceptors.response.forEach((interceptor) => {
            const hasFulfilledHandler = hasMatchingHandler(this.interceptors.response.handlers, interceptor.fulfilled);
            const hasRejectedHandler = hasMatchingHandler(this.interceptors.response.handlers, interceptor.rejected);

            if (!hasFulfilledHandler || !hasRejectedHandler) {
                this.interceptors.response.use(interceptor.fulfilled, interceptor.rejected);
            }
        });

        return originalRequest.apply(this, [updatedConfig]);
    };

    return axios.create();
};

export default axiosInstance;
